var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTorus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0016 0.292969C32.097 0.292969 41.0895 9.24609 41.0895 20.293C41.0895 31.3398 32.097 40.293 21.0016 40.293C9.90616 40.293 0.913696 31.3398 0.913696 20.293C0.913696 9.24609 9.90616 0.292969 21.0016 0.292969Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4669_283496)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7897 10.293C12.781 10.293 11.962 11.1319 11.962 12.1652V14.3457C11.962 15.3791 12.781 16.218 13.7897 16.218H17.0248V28.4207C17.0248 29.4541 17.8438 30.293 18.8525 30.293H20.9812C21.99 30.293 22.809 29.4541 22.809 28.4207V14.3624C22.809 14.3624 22.809 14.3513 22.809 14.3457V12.1652C22.809 11.1319 21.99 10.293 20.9812 10.293H13.7897Z",
    fill: "#0364FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1484 16.218C28.7456 16.218 30.0418 14.8902 30.0418 13.2541C30.0418 11.618 28.7456 10.293 27.1484 10.293C25.5512 10.293 24.255 11.6207 24.255 13.2569C24.255 14.893 25.5512 16.2207 27.1484 16.2207V16.218Z",
    fill: "#0364FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4669_283496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.0791,
    height: 20,
    fill: "white",
    transform: "translate(11.962 10.293)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTorus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/torus.6dcdf1f40f5a412e597d43c365e0d24f.svg";